var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"setting-control-container"},[_c(_setup.IconButton,{attrs:{"title":"设置","icon-name":_setup.iconName},on:{"click":_setup.handleShowSettingDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }